import { gql, useMutation } from '@apollo/client';

import type {
  RecordNuxGoalFactMutation,
  RecordNuxGoalFactMutationVariables,
} from './__generated__/useRecordNuxGoalFact.gql';

const RECORD_NUX_GOAL_FACT = gql`
  mutation RecordNuxGoalFact($input: RecordNuxGoalFactInput!) {
    recordNuxGoalFact(input: $input)
  }
`;

/**
 * Reports a page the member opened, for their NUX goals. Resolves to whether
 * it was their first of that kind today; nothing in the cache changes.
 */
export const useRecordNuxGoalFact = () =>
  useMutation<RecordNuxGoalFactMutation, RecordNuxGoalFactMutationVariables>(RECORD_NUX_GOAL_FACT);
